// module search
export const SET_SEARCH_QUERY = 'SET_SEARCH_QUERY';
export const SET_SEARCH_MOVIES = 'SET_SEARCH_MOVIES';
export const REMOVE_UNUSED_MOVIES = 'REMOVE_UNUSED_MOVIES';
export const SET_STATUS_SEARCHED = 'SET_STATUS_SEARCHED';

// module recommendation
export const SET_RECOMMENDED_MOVIES = 'SET_RECOMMENDED_MOVIES';
export const REMOVE_RECOMMENDED_MOVIES = 'REMOVE_RECOMMENDED_MOVIES';
export const INCREASE_REQUEST_RECOMMENDED_MOVIES = 'INCREASE_REQUEST_RECOMMENDED_MOVIES';
export const RESET_REQUEST_RECOMMENDED_MOVIES = 'RESET_REQUEST_RECOMMENDED_MOVIES';
export const SET_RECOMMENDED_MAIN_MOVIE = 'SET_RECOMMENDED_MAIN_MOVIE';

// module app
export const SET_GENRES = 'SET_GENRES';
export const TOGGLE_ERROR_QUERY = 'TOGGLE_ERROR_QUERY';
export const DISABLE_INTRO = 'DISABLE_INTRO';
export const TOGGLE_MOVIE_DETAIL = 'TOGGLE_MOVIE_DETAIL';
export const SET_MOVIE_DETAIL = 'SET_MOVIE_DETAIL';
